// extracted by mini-css-extract-plugin
export default {"quantityContainer":"QuantityChoice-quantityContainer_XGwiA","quantityCounter":"QuantityChoice-quantityCounter_nTA1e","quantityTitle":"QuantityChoice-quantityTitle_QAhOi"};